var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('video',{ref:"videoElement",attrs:{"autoplay":"","controls":"","height":"100%","muted":"","width":"100%"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }